import { useEffect, useState } from 'react'

import { message } from 'antd'

import store from 'core/application/commons/localStorage'

export type SendQueryRequestOptions = {
  showErrors: boolean
}

/**
 * @deprecated The method should not be used. Please use useQueryRequestV2 instead.
 */
export default <T = undefined>(
  initialState?: T,
  func?: () => Promise<T>,
  opts?: SendQueryRequestOptions,
): [
  T,
  boolean,
  (func: () => Promise<T>, opts?: SendQueryRequestOptions) => Promise<T | null>,
  () => Promise<T | null>,
  boolean,
] => {
  const [isLoading, setIsLoading] = useState(false)

  const productId = store.getLastProductId()
  const [data, setData] = useState<T>(initialState)
  const [hasError, setHasError] = useState<boolean>(false)

  const sendQueryRequest = async (
    overrideFunc?: () => Promise<T>,
    overrideOpts?: SendQueryRequestOptions,
  ): Promise<T> => {
    const funcToExecute = overrideFunc ?? func
    if (!funcToExecute) throw new Error('No function specified to execute')

    try {
      setIsLoading(true)
      setHasError(false)
      const result = await funcToExecute()
      setData(result)
      setIsLoading(false)
      return result
    } catch (err) {
      setIsLoading(false)
      setHasError(true)
      if (err && err.status === 401) {
        ;(window.location.href as any) = `/login?productId=${productId}`
        return null
      }
      const options = overrideOpts ?? opts
      const displayErrors = !options || options.showErrors

      if (displayErrors) {
        message.error('An error occurred while getting the data.')
      }

      return null
    }
  }

  const reload = (): Promise<T> => {
    return sendQueryRequest(func, opts)
  }

  useEffect(() => {
    if (func) {
      sendQueryRequest(func, opts).then(() => {})
    }
  }, [])

  return [data, isLoading, sendQueryRequest, reload, hasError]
}
